var map;
var markers = [];
var infoWindow;
var bounds;
var markerIcon = '';

function initMap() {
    var mapOptions = {
        center: new google.maps.LatLng(28.7041, 77.1025), 
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        zoomControl: true,
        zoom: 4,
        maxZoom: 14
    };
    
    map = new google.maps.Map(
        document.getElementById('map'),
        mapOptions
    );
    
    infoWindow = new google.maps.InfoWindow();
    infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -5)});
}

function clearMap() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }

    markers = [];
}

function clearMarkerAnimation(excludeIdx) 
{
    for (var i = 0; i < markers.length; i++) {
        if (excludeIdx != i) {
            markers[i].setAnimation(null);
        }
    }
}

function getFormatContent(idx) {

    var location = jQuery('div.locationItems').eq(idx);
    var name = location.attr('data-title');
    var content = location.find('.store-content').html();
    var pageLink = location.attr('data-page-link');
    var html = `<div class="map-box"><a href="${pageLink}" target="_blank"><h5>${name}</h5>${content != '' ? `<div class="store-content">${content}</div>` : ``}</a></div>`;
    
    return html;
}

function setLocationsOnMap(locations) {

    bounds = new google.maps.LatLngBounds();

    locations.each(function (idx) {
        var lat = $(this).attr('data-lat');
        var lng = $(this).attr('data-lng');
        var title = $(this).attr('data-title');

        if (lat == 0 && lng == 0) { return; }
        
        var markerOptions = {
            id: (idx + 1),
            position: new google.maps.LatLng(lat, lng),
            title: title,
            map: map
        };

        if (markerIcon != undefined && markerIcon != '') {
            markerOptions.icon = {
                url: markerIcon,
                scaledSize: new google.maps.Size(35, 35)
            };
        }

        var marker = new google.maps.Marker(markerOptions);
        
        google.maps.event.addListener(marker, 'click', function() {
            var content = getFormatContent(marker.id - 1);
            infoWindow.setContent(content);
            infoWindow.open(map, marker);
            map.setZoom(14);
            map.setCenter(marker.getPosition());
        });
        
        markers.push(marker);

        bounds.extend(marker.position);
    });

    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds);
    map.panToBounds(bounds);

    infoWindow.addListener('closeclick', ()=>{
        map.setCenter(bounds.getCenter());
        map.fitBounds(bounds);
        map.panToBounds(bounds);
    });
    
}

function initializeMap() {
    
    initMap();
    var locations = jQuery('div.locationItems');
    clearMap();
    if (locations.length > 0) 
        setLocationsOnMap(locations);
}

$( function() {

    // map-view and grid-view js
    $(".store-map-view").hide();

    $(".map-view-store").click(function() {
        initializeMap();
       
        $(".store-box-container").addClass("stack-view");
        $(".store-map-view").show();

        $(this).addClass('active');
        $(".grid-view-store").removeClass('active');
    });

    $(".grid-view-store").click(function(){
        $(".store-box-container").removeClass("stack-view");
        $(".store-map-view").hide();

        $(this).addClass('active');
        $(".map-view-store").removeClass('active');
    });

    // highlight marker on map
    $(document).on('click', 'span.btnShowMarker', function (e) {
        
        if (!$(".map-view-store").hasClass('active')) {
            $(".map-view-store").trigger('click');
        }
        
        var idx = $('span.btnShowMarker').index(this);

        clearMarkerAnimation(idx);

        if (markers[idx].getAnimation() != google.maps.Animation.BOUNCE) {
            markers[idx].setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function () {
                markers[idx].setAnimation(null);
            }, 1400);
            
        } else {
            markers[idx].setAnimation(null);
        }

        map.fitBounds(bounds);
        map.panToBounds(bounds);
        infoWindow.close();
    });

});